import { MDCSlider } from '@material/slider'

/*

Description of hack/Workaround

Problem:

MD is blocking the native input "change" event from occuring on sliders and
only triggering it when the user clicks away / slider looses focus. This means
that the LV form validation is not being triggered as the user changes the
slider but only when they click/tab to the next input, so we can't dynamically
update the map as the slider moves.

Solution:

As we do want the surpressed "change" events we need to detect when change occurs
and manually trigger "change" on the input ourselves. We can do this by listening
for "MDCSlider:change" and then dispatching "change" on the embedded input.

Doing this though in turn causes an "MDCSlider:change" and thus an infinite loop,
this is why we're removing and then adding back the event listener.

Additionally when the Hook is used updates are being ignored as otherwise for
some weird reason this was blocking display of the thumb label for "discrete"
sliders. Too much re-rendering I think.

Note: on Firefox there is a second "change" event triggered when the slider loses
focus meaning the LV receives a duplicate set of params to validate.

*/

export default {
  makeChangeHandler(el) {
    const handler = function () {
      el.removeEventListener('MDCSlider:change', handler)
      el.querySelector('.mdc-slider__input').dispatchEvent(
        new Event('change', { bubbles: true })
      )
      el.addEventListener('MDCSlider:change', handler)
    }
    return handler
  },
  setup() {
    this.slider = new MDCSlider(this.el)
  },
  destroy() {
    this.slider?.destroy()
    this.slider = null
  },
  mounted() {
    this.setup()
    this.el.addEventListener(
      'MDCSlider:change',
      this.makeChangeHandler(this.el)
    )
  },
  beforeUpdate() {
    this.destroy()
  },
  updated() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
